import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { BadgeNumber } from "./BadgeNumber";
import { InputMoney } from "./InputMoney";
import { toNumber } from "@helpers/incomeProfileHelpers";
import { Expense } from "@interfaces/incomeProfile";

interface Props {
  expense: Expense;
  /** Número visible del concepto (1, 2, 3…). */
  n: number;
  /** Total de ingresos mensuales, para mostrar el peso del gasto. */
  totalIncome: number;
  onChange: (amount: string) => void;
  testId: string;
}

/**
 * Replica `.mp-g`: un concepto de egreso con su monto mensual y el porcentaje que representa sobre
 * los ingresos. En móvil el monto baja debajo del texto.
 */
export const RowExpense = ({ expense, n, totalIncome, onChange, testId }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const percentage = totalIncome > 0 ? (toNumber(expense.amount) / totalIncome) * 100 : 0;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: isMobile ? "22px minmax(0, 1fr)" : "22px minmax(0, 1fr) 210px",
        alignItems: "center",
        gap: isMobile ? "8px 10px" : "12px",
        p: "12px 14px",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "12px",
        bgcolor: "background.paper",
      }}
    >
      <BadgeNumber n={n} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
        <Typography variant="body2" color="tokens.textPrimary" sx={{ lineHeight: 1.4 }}>
          {expense.label}
        </Typography>
        <Typography variant="body3" color="tokens.textTertiary">
          {expense.note}
          {percentage >= 0.1 && ` · ${percentage.toFixed(1)}% de los ingresos`}
        </Typography>
      </Box>
      <Box sx={{ gridColumn: isMobile ? 2 : "auto" }}>
        <InputMoney value={expense.amount} onChange={onChange} width="100%" testId={testId} />
      </Box>
    </Box>
  );
};
